module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-5.5584789d.svg";